import { Seo } from "@/components/Seo";
import { AREAS, BUSINESS } from "@/lib/site";
import { Hero } from "@/components/home/Hero";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { Showcase } from "@/components/home/Showcase";
import { Process } from "@/components/home/Process";
import { Reviews } from "@/components/home/Reviews";
import { Areas } from "@/components/home/Areas";
import { CtaBand } from "@/components/home/CtaBand";

const TITLE = "Extensions, Lofts & Plastering Molesey | DMS Home Improvements";
const DESCRIPTION =
  "Family-run builders and plasterers in Molesey, Kingston and South West London. Extensions, loft conversions, kitchens, bathrooms and plastering. Free site visit and fixed written quote.";

const JSON_LD = {
  "@context": "https://schema.org",
  "@type": ["GeneralContractor", "LocalBusiness"],
  "@id": `${BUSINESS.siteUrl}/#business`,
  name: BUSINESS.name,
  url: BUSINESS.siteUrl,
  telephone: BUSINESS.phoneE164,
  email: BUSINESS.email,
  image: `${BUSINESS.siteUrl}/images/hero-rear-extension-molesey.webp`,
  logo: `${BUSINESS.siteUrl}/images/dms-home-improvements-logo-large.webp`,
  description: DESCRIPTION,
  priceRange: "££",
  address: {
    "@type": "PostalAddress",
    streetAddress: BUSINESS.address.street,
    addressLocality: BUSINESS.address.locality,
    addressRegion: BUSINESS.address.region,
    postalCode: BUSINESS.address.postcode,
    addressCountry: BUSINESS.address.country,
  },
  areaServed: AREAS.map((a) => ({ "@type": "Place", name: a.name })),
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "08:00", closes: "18:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "08:00", closes: "13:00" },
  ],
  knowsAbout: ["House extensions", "Loft conversions", "Plastering", "Kitchen fitting", "Bathroom installation", "Property refurbishment"],
};

export default function Home() {
  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} jsonLd={JSON_LD} />
      <Hero />
      <ServicesGrid />
      <Showcase />
      <Process serif />
      <Reviews />
      <Areas />
      <CtaBand serif />
    </>
  );
}
